module.exports = __webpack_public_path__ + "static/media/flowers_14.b224a4e2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_14.csv
// module id = 753
// module chunks = 0